export default __webpack_public_path__ + "static/tennis-ab129b2b2a60567614d9d85d711b6b4c.mp4";